import React, { useState } from "react";
import { Option } from "./style";

const ToggleButton = (props) => {
  const [mode, setMode] = useState("product");
  const handleClick = (newMode) => {
    if (mode !== newMode) {
      setMode(newMode);
      props.onClick(newMode);
    }
  };

  return (
    <div className="rounded-1 btn-group me-3">
      <Option
        onClick={() => handleClick("product")}
        className={`default-option ${
          mode === "product" ? "selected-option" : ""
        }`}
      >
        Info
      </Option>
      {!props.hideInternals && (
        <Option
          onClick={() => handleClick("spaceConfig")}
          className={`default-option ${
            mode === "spaceConfig" ? "selected-option" : ""
          }`}
        >
          Internals
        </Option>
      )}
      {!props.hideExternals && (
        <Option
          onClick={() => handleClick("shutterConfig")}
          className={`default-option ${
            mode === "shutterConfig" ? "selected-option" : ""
          }`}
        >
          Externals
        </Option>
      )}
      <Option
        onClick={() => handleClick("cutlist")}
        className={`default-option ${
          mode === "cutlist" ? "selected-option" : ""
        }`}
      >
        Cutlist
      </Option>
    </div>
  );
};

export default ToggleButton;
